 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1SUMMERNIGHT from '@/components/0_chapter1summernight'
 import A_CHAPTER2THATWEEKEND from '@/components/1_chapter2thatweekend'
 import A_CHAPTER3STARTLED from '@/components/2_chapter3startled'
 import A_CHAPTER4TREATMELIKEASISTER from '@/components/3_chapter4treatmelikeasister'
 import A_CHAPTER5ASTHENIAOFHEART from '@/components/4_chapter5astheniaofheart'
 import A_CHAPTER6BETTER from '@/components/5_chapter6better'
 import A_CHAPTER7PRIVATEPARTY from '@/components/6_chapter7privateparty'
 import A_CHAPTER8IMPORTANCE from '@/components/7_chapter8importance'
 import A_CHAPTER9UNDERTHEWARMLAMP from '@/components/8_chapter9underthewarmlamp'
 import A_CHAPTER10WALKUPANDDOWN from '@/components/9_chapter10walkupanddown'
 import A0_CHAPTER11SUCCESSOR from '@/components/10_chapter11successor'
 import A1_CHAPTER12BETWEENQINGERANDLIUYUE from '@/components/11_chapter12betweenqingerandliuyue'
 import A2_CHAPTER13SISBELIEVESINYOU from '@/components/12_chapter13sisbelievesinyou'
 import A3_CHAPTER14EYEOPENER from '@/components/13_chapter14eyeopener'
 import A4_CHAPTER15ALWAYSREMEMBER from '@/components/14_chapter15alwaysremember'
 import A5_CHAPTER16SIMPLE from '@/components/15_chapter16simple'
 import A6_CHAPTER17INEEDYOUTOGIVEMESOMEPOINTERS from '@/components/16_chapter17ineedyoutogivemesomepointers'
 import A7_CHAPTER18HANDTEACHING from '@/components/17_chapter18handteaching'
 import A8_CHAPTER19ARRIVINGATTHEPROVINCIALCAPITAL from '@/components/18_chapter19arrivingattheprovincialcapital'
 import A9_CHAPTER20HEWALKEDALLTHEWAYTOTHENIGHTMARKET from '@/components/19_chapter20hewalkedallthewaytothenightmarket'
 import A0_CHAPTER21LETSJUSTLETTHISGO from '@/components/20_chapter21letsjustletthisgo'
 import A1_CHAPTER22LIKETHEFIRSTTIME from '@/components/21_chapter22likethefirsttime'
 import A2_CHAPTER23SPEEDNOTQUALITY from '@/components/22_chapter23speednotquality'
 import A3_CHAPTER24NOTBEINGABLETOBEALONE from '@/components/23_chapter24notbeingabletobealone'
 import A4_CHAPTER25INTHEAUTUMNNIGHT from '@/components/24_chapter25intheautumnnight'
 import A5_CHAPTER26NOONEKNOWS from '@/components/25_chapter26nooneknows'
 import A6_CHAPTER27YOURENOTAFRAIDOFMEONABUSINESSTRIP from '@/components/26_chapter27yourenotafraidofmeonabusinesstrip'
 import A7_CHAPTER28ITACTUALLYTASTEDLIKECHEWINGWAX from '@/components/27_chapter28itactuallytastedlikechewingwax'
 import A8_CHAPTER29OLTHREEHASACHANCENOW from '@/components/28_chapter29olthreehasachancenow'
 import A9_CHAPTER30DONTBELITTLEYOURSELFSOMUCH from '@/components/29_chapter30dontbelittleyourselfsomuch'
 import A0_CHAPTER31SILENTLYRETRACTINGHISGAZE from '@/components/30_chapter31silentlyretractinghisgaze'
 import A1_CHAPTER32BALANCEFOUND from '@/components/31_chapter32balancefound'
 import A2_CHAPTER33ITSBETTERTOBEWHEREYOUARE from '@/components/32_chapter33itsbettertobewhereyouare'
 import A3_CHAPTER34IKNOW from '@/components/33_chapter34iknow'
 import A4_CHAPTER35MOMANDDADWEREBOTHSTUNNED from '@/components/34_chapter35momanddadwerebothstunned'
 import A5_CHAPTER36WRAPYOURARMSAROUNDMYWAIST from '@/components/35_chapter36wrapyourarmsaroundmywaist'
 import A6_CHAPTER37THESELLERSREQUESTFORHONOR from '@/components/36_chapter37thesellersrequestforhonor'
 import A7_CHAPTER38GREATFACE from '@/components/37_chapter38greatface'
 import A8_CHAPTER39SMILE from '@/components/38_chapter39smile'
 import A9_CHAPTER40NOANSWER from '@/components/39_chapter40noanswer'
 import A0_CHAPTER41SERENITY from '@/components/40_chapter41serenity'
 import A1_CHAPTER42ITSTIMETOGETOFFWORK from '@/components/41_chapter42itstimetogetoffwork'
 import A2_CHAPTER43WHETHERSWEETORSPICY from '@/components/42_chapter43whethersweetorspicy'
 import A3_CHAPTER44CEREBRALVERTIGO from '@/components/43_chapter44cerebralvertigo'
 import A4_CHAPTER45DONTBELITTLEYOURSELFSOMUCH from '@/components/44_chapter45dontbelittleyourselfsomuch'
 import A5_CHAPTER46OLDTHIRDWASEXPRESSIONLESS from '@/components/45_chapter46oldthirdwasexpressionless'
 import A6_CHAPTER47YOUSTUPIDFOOL from '@/components/46_chapter47youstupidfool'
 import A7_CHAPTER48ITHASNOTHINGTODOWITHSENIORITY from '@/components/47_chapter48ithasnothingtodowithseniority'
 import A8_CHAPTER49SEERIGHTTHROUGHMYMIND from '@/components/48_chapter49seerightthroughmymind'
 import A9_CHAPTER50ASIEXPECTED from '@/components/49_chapter50asiexpected'
 import A0_CHAPTER51FALLASLEEPAGAIN from '@/components/50_chapter51fallasleepagain'
 import A1_CHAPTER52LEASTPROMISING from '@/components/51_chapter52leastpromising'
 import A2_CHAPTER53IVEBEENBUSYLATELY from '@/components/52_chapter53ivebeenbusylately'
 import A3_CHAPTER54NOTPERCEIVING from '@/components/53_chapter54notperceiving'
 import A4_CHAPTER55CANTWAIT from '@/components/54_chapter55cantwait'
 import A5_CHAPTER56DIDNOTFOLLOW from '@/components/55_chapter56didnotfollow'
 import A6_CHAPTER57DECONTAMINATION from '@/components/56_chapter57decontamination'
 import A7_CHAPTER58UNSPEAKABLETASTE from '@/components/57_chapter58unspeakabletaste'
 import A8_CHAPTER59THATKINDOFWINTER from '@/components/58_chapter59thatkindofwinter'
 import A9_CHAPTER60THREATSANDOBSTACLES from '@/components/59_chapter60threatsandobstacles'
 import A0_CHAPTER61WHATAREYOUGAWKINGAT from '@/components/60_chapter61whatareyougawkingat'
 import A1_CHAPTER62HIGHVIGILANCE from '@/components/61_chapter62highvigilance'
 import A2_CHAPTER63DOYOUREMEMBERTHEPAST from '@/components/62_chapter63doyourememberthepast'
 import A3_CHAPTER64LIUYUECALLED from '@/components/63_chapter64liuyuecalled'
 import A4_CHAPTER65HADAGLASSOFBITTERWINE from '@/components/64_chapter65hadaglassofbitterwine'
 import A5_CHAPTER66EVENSO from '@/components/65_chapter66evenso'
 import A6_CHAPTER67YOULOVEHER from '@/components/66_chapter67youloveher'
 import A7_CHAPTER68ITSALLMYFAULT from '@/components/67_chapter68itsallmyfault'
 import A8_CHAPTER69FOLKCUSTOMS from '@/components/68_chapter69folkcustoms'
 import A9_CHAPTER70PRETENDNOTTOSEE from '@/components/69_chapter70pretendnottosee'
 import A0_CHAPTER71OTHERFEELINGS from '@/components/70_chapter71otherfeelings'
 import A1_CHAPTER72YOUREOLD from '@/components/71_chapter72youreold'
 import A2_CHAPTER73MORETYPICALGROUP from '@/components/72_chapter73moretypicalgroup'
 import A3_CHAPTER74SPECIALRELATION from '@/components/73_chapter74specialrelation'
 import A4_CHAPTER75HOLDHERBYTHETHROAT from '@/components/74_chapter75holdherbythethroat'
 import A5_CHAPTER76SURFACESLOPPY from '@/components/75_chapter76surfacesloppy'
 import A6_CHAPTER77ICESHOCK from '@/components/76_chapter77iceshock'
 import A7_CHAPTER78IDONTKNOWHOWTOTHANKYOU from '@/components/77_chapter78idontknowhowtothankyou'
 import A8_CHAPTER79WHATAGREATLEADER from '@/components/78_chapter79whatagreatleader'
 import A9_CHAPTER80DIFFICULTDAY from '@/components/79_chapter80difficultday'
 import A0_CHAPTER81AFORTUITOUSENCOUNTERINTHENIGHT from '@/components/80_chapter81afortuitousencounterinthenight'
 import A1_CHAPTER82TACITCONGRATULATIONS from '@/components/81_chapter82tacitcongratulations'
 import A2_CHAPTER83LIUFEISGIRLFRIEND from '@/components/82_chapter83liufeisgirlfriend'
 import A3_CHAPTER84EMOTIONSONNEWYEARSEVE from '@/components/83_chapter84emotionsonnewyearseve'
 import A4_CHAPTER85PAPERAIRPLANE from '@/components/84_chapter85paperairplane'
 import A5_CHAPTER86THATUNFORGETTABLESPRINGFESTIVAL from '@/components/85_chapter86thatunforgettablespringfestival'
 import A6_CHAPTER87AGUESTATBROTHERYANGSHOUSE from '@/components/86_chapter87aguestatbrotheryangshouse'
 import A7_CHAPTER88LOOKAROUNDALLDAYLONG from '@/components/87_chapter88lookaroundalldaylong'
 import A8_CHAPTER89AMANWITHOUTACONSCIENCE from '@/components/88_chapter89amanwithoutaconscience'
 import A9_CHAPTER90MOUNTAINRESEARCH from '@/components/89_chapter90mountainresearch'
 import A0_CHAPTER91REALINTENT from '@/components/90_chapter91realintent'
 import A1_CHAPTER92IVEBEENMAKINGLOVETOMYSELFFORSOLONG from '@/components/91_chapter92ivebeenmakinglovetomyselfforsolong'
 import A2_CHAPTER93BOTHARECOMRADESINTHEREVOLUTION from '@/components/92_chapter93botharecomradesintherevolution'
 import A3_CHAPTER94DONOTUNDERESTIMATETHISLIST from '@/components/93_chapter94donotunderestimatethislist'
 import A4_CHAPTER95PERSEVERANCEANDFIRMNESS from '@/components/94_chapter95perseveranceandfirmness'
 import A5_CHAPTER96YANGGESPRIVATEBANQUET from '@/components/95_chapter96yanggesprivatebanquet'
 import A6_CHAPTER97MINISTERZHANGSTEASING from '@/components/96_chapter97ministerzhangsteasing'
 import A7_CHAPTER98CLINKWITHLIUYUE from '@/components/97_chapter98clinkwithliuyue'
 import A8_CHAPTER99FLAWLESS from '@/components/98_chapter99flawless'
 import A9_CHAPTER100THANKTHEGODOFFATE from '@/components/99_chapter100thankthegodoffate'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1summernight",
 			"name" : "0_chapter1summernight",
 			"component" : A_CHAPTER1SUMMERNIGHT
 		},
 		{
 			"path" : "/1_chapter2thatweekend",
 			"name" : "1_chapter2thatweekend",
 			"component" : A_CHAPTER2THATWEEKEND
 		},
 		{
 			"path" : "/2_chapter3startled",
 			"name" : "2_chapter3startled",
 			"component" : A_CHAPTER3STARTLED
 		},
 		{
 			"path" : "/3_chapter4treatmelikeasister",
 			"name" : "3_chapter4treatmelikeasister",
 			"component" : A_CHAPTER4TREATMELIKEASISTER
 		},
 		{
 			"path" : "/4_chapter5astheniaofheart",
 			"name" : "4_chapter5astheniaofheart",
 			"component" : A_CHAPTER5ASTHENIAOFHEART
 		},
 		{
 			"path" : "/5_chapter6better",
 			"name" : "5_chapter6better",
 			"component" : A_CHAPTER6BETTER
 		},
 		{
 			"path" : "/6_chapter7privateparty",
 			"name" : "6_chapter7privateparty",
 			"component" : A_CHAPTER7PRIVATEPARTY
 		},
 		{
 			"path" : "/7_chapter8importance",
 			"name" : "7_chapter8importance",
 			"component" : A_CHAPTER8IMPORTANCE
 		},
 		{
 			"path" : "/8_chapter9underthewarmlamp",
 			"name" : "8_chapter9underthewarmlamp",
 			"component" : A_CHAPTER9UNDERTHEWARMLAMP
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js